import React, { useState } from "react";
import Footer from "../Footer";
import { NewNavbar } from "../Pages/NewNavbar";
import buyerCenterImg from "../../../assets/image/buyer-banner-center-img.png";

import WhatYouGainSection from "../Components/UI/WhatYouGainSection";
import claim from "../../../assets/image/claim.png";

import gift from "../../../assets/image/gift.gif";

import Guide from "./Guide";
export default function BuyerGuide() {
  const infoCards = [
    {
      desc: "A buyer's guide provides clear direction at every step, so you always know what's next in the homebuying journey.",
      icon: "/icon3/icon1.png",
    },
    {
      desc: "It equips you with the knowledge you need to make confident, informed decisions from start to finish.",
      icon: "/icon3/icon2.png ",
    },
    {
      desc: "You'll benefit from expert insights curated by the Milford team, making the process smooth and personalized.",
      icon: "/icon3/icon3.png",
    },
    {
      desc: "A clear plan means you can enjoy a stress-free experience and focus on the excitement of finding your new home.",
      icon: "/icon3/icon4.png",
    },
  ];

  return (
    <>
      <NewNavbar buySellActive={false} />
      {/* Buyer Guide banner section start */}
      <div className="buyer-guide-main-section container-fluid">
        <div className="container">
          <div className="row">
        <div className="center-img text-center">
          <img src={buyerCenterImg} alt="" className="img-fluid"/>
          <div className="img-content-wrap">
            <h1>Hello!</h1>
            <p>
              We're excited to help you start this journey! Below is a link to
              your <b> Milford Homebuyer Guide </b> designed to walk you through
              every step of buying a home with clarity and confidence.
            </p>
          </div>
        </div>
          </div>
        </div>
      </div>
      {/* Buyer Guide banner section end */}
      <WhatYouGainSection
        bookSrc={claim}
        bottomSection={false}
        infoCard={infoCards}
        title={"What To Expect From Your Buyer's Guide"}
        subtitle={"YOUR JOURNEY. MADE SIMPLE."}
        topIcon={gift}
        customClass={"col-md-6 col-xl-3"}
      />
      <div className="bookFrame" style={{ height: "100vh", width: "100%" }}>
        <iframe
          src="https://d3ms8mre5rhtvu.cloudfront.net?hash=QkQ4OUFBQkJEQzkrZG5sb3Nzc24zMA==&cd=https://magazines.milford.com"
          width="100%"
          height="100%"
          scrolling="no"
          frameBorder="0"
          allowFullScreen
          allow="autoplay; clipboard-read; clipboard-write"
        ></iframe>
      </div>

      <Guide />
      <Footer />
    </>
  );
}
